import React from 'react';
import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Toolbar,
  Divider,
  ListSubheader,
  Typography
} from '@mui/material';
import {
  Phone as PhoneIcon,
  Help as HelpIcon,
  Info as AboutIcon,
  PersonAdd as PersonAddIcon,
  Dashboard as DashboardIcon,
  AdminPanelSettings as AdminIcon,
} from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const drawerWidth = 280;

const FixedSidebar: React.FC = () => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          borderRight: '1px solid rgba(0, 0, 0, 0.12)',
          backgroundColor: '#1134A6'
        }
      }}
    >
      <Toolbar>
        <Typography variant="h6" noWrap component="div" sx={{ fontWeight: 'bold', color: 'white' }}>
          NeighborhoodPulse
        </Typography>
      </Toolbar>
      
             <Box sx={{ overflow: 'auto' }}>


        {/* Reviews moved to sidebar Explore */}
        <List subheader={<ListSubheader component="div" sx={{ color: 'white', backgroundColor: 'transparent' }}>Explore</ListSubheader>}>
          <ListItemButton 
            component={Link} 
            to="/reviews" 
            selected={isActive('/reviews')}
            sx={{ 
              '&.Mui-selected': { 
                backgroundColor: 'primary.light',
                '&:hover': { backgroundColor: 'primary.light' }
              }
            }}
          >
            <ListItemIcon />
            <ListItemText primary="Reviews" sx={{ color: 'white' }} />
          </ListItemButton>
        </List>
        <Divider />

        {/* Help Section */}
        <List subheader={<ListSubheader component="div" sx={{ color: 'white', backgroundColor: 'transparent' }}>Help</ListSubheader>}>
          <ListItemButton 
            component={Link} 
            to="/contact" 
            selected={isActive('/contact')}
            sx={{ 
              '&.Mui-selected': { 
                backgroundColor: 'primary.light',
                '&:hover': { backgroundColor: 'primary.light' }
              }
            }}
          >
            <ListItemIcon sx={{ color: 'white' }}>
              <PhoneIcon />
            </ListItemIcon>
            <ListItemText primary="Contact Us" sx={{ color: 'white' }} />
          </ListItemButton>
          
          <ListItemButton 
            component={Link} 
            to="/faq" 
            selected={isActive('/faq')}
            sx={{ 
              '&.Mui-selected': { 
                backgroundColor: 'primary.light',
                '&:hover': { backgroundColor: 'primary.light' }
              }
            }}
          >
            <ListItemIcon sx={{ color: 'white' }}>
              <HelpIcon />
            </ListItemIcon>
            <ListItemText primary="FAQ" sx={{ color: 'white' }} />
          </ListItemButton>
          
          <ListItemButton 
            component={Link} 
            to="/about" 
            selected={isActive('/about')}
            sx={{ 
              '&.Mui-selected': { 
                backgroundColor: 'primary.light',
                '&:hover': { backgroundColor: 'primary.light' }
              }
            }}
          >
            <ListItemIcon sx={{ color: 'white' }}>
              <AboutIcon />
            </ListItemIcon>
            <ListItemText primary="About" sx={{ color: 'white' }} />
          </ListItemButton>
        </List>

        <Divider />

        {/* For Providers */}
        <List subheader={<ListSubheader component="div" sx={{ color: 'white', backgroundColor: 'transparent' }}>For Providers</ListSubheader>}>
          <ListItemButton 
            component={Link} 
            to="/provider-register" 
            selected={isActive('/provider-register')}
            sx={{ 
              '&.Mui-selected': { 
                backgroundColor: 'primary.light',
                '&:hover': { backgroundColor: 'primary.light' }
              }
            }}
          >
            <ListItemIcon sx={{ color: 'white' }}>
              <PersonAddIcon />
            </ListItemIcon>
            <ListItemText primary="Provider Register" sx={{ color: 'white' }} />
          </ListItemButton>
        </List>

        {/* My Account Section (Bookings removed, keep Provider Dashboard and Admin) */}
        {isAuthenticated && (
          <>
            <List subheader={<ListSubheader component="div" sx={{ color: 'white', backgroundColor: 'transparent' }}>My Account</ListSubheader>}>
              <ListItemButton 
                component={Link} 
                to="/provider-dashboard" 
                selected={isActive('/provider-dashboard')}
                sx={{ 
                  '&.Mui-selected': { 
                    backgroundColor: 'primary.light',
                    '&:hover': { backgroundColor: 'primary.light' }
                  }
                }}
              >
                <ListItemIcon sx={{ color: 'white' }}>
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="My Bookings" sx={{ color: 'white' }} />
              </ListItemButton>
              
              {user?.role === 'admin' && (
                <ListItemButton 
                  component={Link} 
                  to="/admin" 
                  selected={isActive('/admin')}
                  sx={{ 
                    '&.Mui-selected': { 
                      backgroundColor: 'primary.light',
                      '&:hover': { backgroundColor: 'primary.light' }
                    }
                  }}
                >
                  <ListItemIcon sx={{ color: 'white' }}>
                    <AdminIcon />
                  </ListItemIcon>
                  <ListItemText primary="Admin Dashboard" sx={{ color: 'white' }} />
                </ListItemButton>
              )}
            </List>
          </>
        )}
      </Box>
    </Drawer>
  );
};

export default FixedSidebar;

